import * as i0 from "@angular/core";
var ReservationIdService = /** @class */ (function () {
    function ReservationIdService() {
    }
    ReservationIdService.prototype.setId = function (reservationId) {
        this.reservationId = Number(reservationId);
    };
    ReservationIdService.prototype.getId = function () {
        return this.reservationId;
    };
    ReservationIdService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReservationIdService_Factory() { return new ReservationIdService(); }, token: ReservationIdService, providedIn: "root" });
    return ReservationIdService;
}());
export { ReservationIdService };
